import {assertAndContinue} from 'Asserts';
import {SqlColumnType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {assertNever} from 'util/Types';

export function sqlColumnTypeToString(sqlColumnType: SqlColumnType): string {
  switch (sqlColumnType) {
    case SqlColumnType.CHARACTER_VARYING:
      return 'varchar';
    case SqlColumnType.BOOLEAN:
      return 'boolean';
    case SqlColumnType.DOUBLE:
      return 'double';
    case SqlColumnType.INTEGER:
      return 'int';
    case SqlColumnType.DATE:
      return 'date';
    case SqlColumnType.TIMESTAMP:
      return 'timestamp';
    case SqlColumnType.JSON:
      return 'json';
    case SqlColumnType.JSONB:
      return 'jsonb';
    case SqlColumnType.NUMERIC:
      return 'numeric';
    case SqlColumnType.UUID:
      return 'varchar';
    case SqlColumnType.UNKNOWN:
      return '';
    default:
      assertAndContinue(false, `Invalid column type ${assertNever(sqlColumnType)}`);
      return 'unknown';
  }
}

export function sqlColumnTypeToIcon(sqlColumnType: SqlColumnType): BenchlingIconName | null {
  switch (sqlColumnType) {
    case SqlColumnType.CHARACTER_VARYING:
      return 'text';
    case SqlColumnType.BOOLEAN:
      return 'boolean';
    case SqlColumnType.DOUBLE:
    case SqlColumnType.INTEGER:
    case SqlColumnType.NUMERIC:
      return 'number';
    case SqlColumnType.DATE:
      return 'calendar';
    case SqlColumnType.TIMESTAMP:
      return 'protocol-timer';
    case SqlColumnType.JSON:
    case SqlColumnType.JSONB:
      return 'brackets';
    case SqlColumnType.UUID:
      return 'text';
    case SqlColumnType.UNKNOWN:
      return null;
    default:
      assertAndContinue(false, `Invalid column type ${assertNever(sqlColumnType)}`);
      return 'notdef';
  }
}
